import "./index.css"
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../../assets/img/project-img1.png";
import projImg2 from "../../assets/img/project-img2.png";
import glowBall from "../../assets/img/project-banner/Glowball.jpg"
import scorge from "../../assets/img/project-banner/Scorge.jpg"
import brawler from "../../assets/img/project-banner/Brawler.jpg"
import blogImg1 from "../../assets/img/game-banner/Blog-1.jpg";
import blogImg2 from "../../assets/img/game-banner/Blog-2.jpg";
import colorSharp2 from "../../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Project = () => {

    const projects = [
        {
            title: "Glow Ball",
            description: "3D-Sidescroller-Platformer",
            imgUrl: glowBall,
            link:"https://kkvasan-dev-projects.blogspot.com/2022/12/glowball.html"

        },
        {
            title: "2D Brawler",
            description: "2D Local PVP",
            imgUrl: brawler,
            link:"#"
        },

        {
            title: "Scorge",
            description: "3D SinglePlayer Horror",
            imgUrl: scorge,
            link:"#"
        },

    ];

    const blogs =[
        {
            title: "Why Game Development?",
            description: "General-Blog",
            imgUrl: blogImg1,
            link:"https://www.google.com/"

        },
        {
            title: "About Unreal Engine",
            description: "General-Blog",
            imgUrl: blogImg2,
            link:"https://www.google.com/"
        },
    ]

    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col size={12}>
                        <TrackVisibility>
                            {({ isVisible }) =>
                                <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                                    <h2>Projects</h2>
                                    <p>In this section, you will find a selection of my projects that showcase my skills in game design,
                                        programming, and project management.
                                        </p>
                                    <Tab.Container id="projects-tabs" defaultActiveKey="first">
                                        <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                            <Nav.Item>
                                                <Nav.Link eventKey="first">Tab 1</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second">Tab 2</Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third">Blog</Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                                            <Tab.Pane eventKey="first">
                                                <Row>
                                                    {
                                                        projects.map((project, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...project}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <br /><br /><br />
                                                <p> Work In progress !!</p>
                                                <br /><br /><br />
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">

                                                <Row>
                                                    {
                                                        blogs.map((project, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...project}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </Row>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2}></img>
        </section>
    )
}
